import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IPatientUnlisted } from "../../../models/IPatientUnlisted"
import { Link } from 'react-router-dom';
import { PATIENT } from '../../../utils/RouteConstants';
import "./PatientsUnlistedTable.scss";
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { dateTimeToDateString } from '../../../helpers/DateHelper';

interface IPatientUnlistedTable {
    id: string | undefined;
    data: IPatientUnlisted[] | undefined;
}

export const PatientsUnlistedTable: React.FunctionComponent<IPatientUnlistedTable> = ({ id, data }) => {

    const goToPatientLink = (text: string, patientGuidId: string) => {
        return (
            <Link to={`/${PATIENT}/${patientGuidId}`}>{text}</Link>
        )
    }

    return (
        <section id={id} className="patient-unlisted-table">
            {
                data
                    ? <Table hoverableRows={data.length > 0}>
                        <thead>
                            <tr>
                                <SortableTableHeader propertyToSortBy="PersonalSecurityId" headerText="Personnummer" />
                                <SortableTableHeader propertyToSortBy="FirstName" headerText="Namn" />
                                <th>Avlistningsorsak</th>
                                <th className="text-right">Olistad datum</th>
                                <th className="text-right">Dagar utan fullständig vårdrapport</th>
                                <th className="text-right">Aktiva remisser</th>
                                <th className="text-right">KEA-åtgärd</th>
                                <th className="text-right">KEA datum</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.length > 0
                                    ? data.map((patient, key) => {
                                        return (
                                            <tr className="clickable-row align-text-bottom" key={key} >
                                                <td className="table-data-link">{goToPatientLink(formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityId), patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.name, patient.patientGuidId)}</td>
                                                <td className="table-data-link">{goToPatientLink(patient.listingStatus, patient.patientGuidId)}</td>
                                                <td className="text-right table-data-link">{goToPatientLink(dateTimeToDateString(patient.lastEndedListingDate), patient.patientGuidId)}</td>
                                                <td className="text-right table-data-link">{goToPatientLink(patient.daysSinceCompleteTreatmentReport !== null ? patient.daysSinceCompleteTreatmentReport!.toString() : "-", patient.patientGuidId)}</td>
                                                <td className="text-right table-data-link">{goToPatientLink(patient.activeReferralTypes, patient.patientGuidId)}</td>
                                                <td className="text-right table-data-link">{goToPatientLink(patient.hasBeenContactedThisYear ? "Ja" : "Nej", patient.patientGuidId)}</td>
                                                <td className="text-right table-data-link">{goToPatientLink(dateTimeToDateString(patient.latestContactedThisYearDate), patient.patientGuidId)}</td>
                                            </tr>
                                        )
                                    })
                                    : <tr><td colSpan={7}>Det finns inga olistade patienter att visa</td></tr>
                            }
                        </tbody>
                    </Table>
                    : null
            }
        </section>
    )
}